<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ $t(titlePage) }}</h1>
                </CCol>
                <CCol class="d-flex justify-content-end">
                    <ButtonCreate
                        :title="$t('Add phone to blacklist')"
                        @click="modals.addPhoneToBlacklist.show = true"
                    >
                        {{ $t("Add phone") }}
                    </ButtonCreate>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.phoneBlacklist.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow
                    v-show="
                        hasItemsInTable({
                            tableName: 'phoneBlacklist',
                        })
                    "
                >
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <div class="d-flex">
                                    <TableSettings
                                        :allFields="
                                            tables.phoneBlacklist.allFields
                                        "
                                        :activeFields.sync="
                                            tables.phoneBlacklist.fields
                                        "
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.phoneBlacklist.items"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.phoneBlacklist.fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :items-per-page="tables.phoneBlacklist.rows"
                                    :loading="tables.phoneBlacklist.loading"
                                    v-bind="tables.phoneBlacklist"
                                    :columnFilterValue.sync="
                                        tables.phoneBlacklist.columnFilterValue
                                    "
                                    :sorterValue.sync="
                                        tables.phoneBlacklist.sorterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @update:sorter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                >
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                endPoint="/headers.api/phones/blacklist"
                                                :table="tables.phoneBlacklist"
                                            />
                                        </div>
                                    </template>
                                    <template #_selected="{ item }">
                                        <td class="py-2">
                                            <CInputRadio
                                                name="_selected"
                                                :checked="
                                                    item ===
                                                    tables.phoneBlacklist
                                                        .itemSelected
                                                "
                                                @update:checked="
                                                    selectItemTable(
                                                        'phoneBlacklist',
                                                        item
                                                    )
                                                "
                                            />
                                        </td>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.phoneBlacklist.total_pages > 0"
                            >
                                <CPagination
                                    @update:activePage="updatePagination"
                                    :activePage="tables.phoneBlacklist.page"
                                    :pages="tables.phoneBlacklist.total_pages"
                                    align="center"
                                />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
                <AddPhoneToBlacklistModal
                    :show.sync="modals.addPhoneToBlacklist.show"
                    v-bind="modals.addPhoneToBlacklist"
                    v-on:submit="afterPhoneAddingToBlacklist"
                    :title="$t('Add phone to blacklist')"
                />
                
            </CContainer>
            <NoItemsContainer
                v-show="
                    !hasItemsInTable({
                        tableName: 'phoneBlacklist',
                    })
                "
            >
                <template #title>
                    {{ $t("Add phone to blacklist") }}
                </template>
                <template #description>
                    {{ $t("You can add an phone to blacklist.") }}
                </template>
                <template #redirect>
                    <ButtonCreate
                        @click="modals.addPhoneToBlacklist.show = true"
                    >
                        {{ $t("Add phone") }}
                    </ButtonCreate>
                </template>
                <template #cleanFilter>
                    <CButton
                        color="primary"
                        class="button"
                        v-show="
                            hasFiltersInTable({
                                tableName: 'phoneBlacklist',
                            })
                        "
                        @click="
                            cleanFiltersAdvance('phoneBlacklist'), updateData()
                        "
                    >
                        <span class="button__icon">
                            <CIcon :content="$options.icons.eraser" />
                        </span>
                        <span class="button__text">
                            {{ $t("Clean filters") }}
                        </span>
                    </CButton>
                </template>
            </NoItemsContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import FilterDate from "~/components/FilterDate";
import ButtonCreate from "~/components/ButtonCreate";
import TableSettings from "£lement/TableSettings";
import ButtonExport from "~/components/ButtonExport";
import FilterFields from "~/components/FilterFields";
import NoItemsContainer from "~/components/NoItemsContainer";
import AddPhoneToBlacklistModal from "../Components/AddPhoneToBlacklistModal.vue";

/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

/** Others */
import {
    cilPlus,
    cilSettings,
    cilReload,
    cilPencil,
    cilChart,
    cilTrash,
    cilArrowThickFromRight,
    cilMediaStop,
    cilMediaPlay,
} from "@coreui/icons";

import PhoneBlacklistTable from "../Config/Tables/PhoneBlacklist";

export default {
    name: "PhonessBlacklistPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        ButtonCreate,
        TableSettings,
        ButtonExport,
        FilterFields,
        NoItemsContainer,
        AddPhoneToBlacklistModal,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
        cilReload,
        cilChart,
        cilMediaPlay,
        cilMediaStop,
    },
    data() {
        return {
            tables: {
                phoneBlacklist: PhoneBlacklistTable,
            },
            modals: {
                addPhoneToBlacklist: {
                    show: false,
                    color: "primary",
                    size: "lg",
                },
            },
        };
    },
    computed:{
        titlePage: function () {
            return "Phones blacklist";
        },
    },
    methods: {
        itemPerPage(newValue) {
            this.tables.phoneBlacklist.rows = newValue;
            this.updatePagination(this.tables.phoneBlacklist.page);
        },
        async updatePagination(newValue) {
            this.tables.phoneBlacklist.page = newValue;
            await this.updateData();
        },
        async updateData() {
            await this.updateTable({
                tableName: "phoneBlacklist",
                url: "/headers.api/phones/blacklist",
            });
            this.tables.phoneBlacklist.itemSelected = null;
            this.tables.phoneBlacklist.loading = false;
            this.updatePageLoading(false);
        },

        afterPhoneAddingToBlacklist(response) {
            this.modals.addPhoneToBlacklist.show = false;
            this.updateData();
        },
    },
    async mounted() {
        await this.updateData();
    },
};
</script>

<style scoped lang="scss">
</style>